import Vue from "vue";
import App from "./App.vue";
import "@/styles/index.scss"; // 全局样式
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VConsole from "vconsole";
import store from "./store";
import router from "./router";
import Vant from "vant";
import { Lazyload } from "vant";
import "vant/lib/index.css";
import topBar from "@/components/topbar/index.vue";
import loading from "@/components/loading/index.vue";
import EmptyData from "@/components/emptyData/index.vue";
import axios from "axios";
Vue.component("topBar", topBar);
Vue.component("loading", loading);
Vue.component("EmptyData", EmptyData);
// 引入 form-create-vant 组件库
import formCreateMobile from "@form-create/vant";
Vue.use(formCreateMobile);
//键盘弹起滚动
import scrollOnFocus from "@/utils/scrollOnFocus";
// 注册全局指令
Vue.directive("scrollFocus", scrollOnFocus);
// 导入复制指令
import "@/utils/copy"; // 注意路径
// 全局注册复制指令
const model = navigator.userAgent;
// 判断是否是安卓手机，是则是true
const androidAttrs =
  model.indexOf("Android") > -1 || model.indexOf("Linux") > -1;
Vue.prototype.isAndroid = androidAttrs;
Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(ElementUI);
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "pre") {
  new VConsole();
}
// new VConsole();
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
